export default "/images/vendor/quill/icons/link.svg?5c302e73950bc52c1afb8cf4f3ceb707";